import { render, staticRenderFns } from "./select-paymentWay.vue?vue&type=template&id=68e735c1&scoped=true"
import script from "./select-paymentWay.vue?vue&type=script&lang=js"
export * from "./select-paymentWay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e735c1",
  null
  
)

export default component.exports